import React from "react";
import useChangePassword from "../hooks/useChangePassword";
import { PASSWORD_CHANGE_TEXT } from "../domain/passwordChange";

// FE-234: Settings' Change password link. It opens B2C's password-reset
// flow in a sign-in window (hooks/useChangePassword.js). There's no input and
// no form here: the password is typed only on B2C's page.
export default function ChangePasswordLink() {
  const { start, pending, text } = useChangePassword();

  return (
    <div className="change-password-link">
      <button
        type="button"
        className={`btn-edit ${pending ? "employee-button-disabled" : ""}`}
        onClick={() => start()}
        disabled={pending}
      >
        Change password
      </button>
      <p>{PASSWORD_CHANGE_TEXT.help}</p>
      <p role="status">{text}</p>
    </div>
  );
}
